import React from "react";

import { SalaryIncomeDetails } from "../income-details";

const TDSOnSalaryDetails: React.FC = () => {
	return (
		<>
			<SalaryIncomeDetails activeTab="DEDUCTION" />
		</>
	);
};

export default TDSOnSalaryDetails;
